module.exports = __webpack_public_path__ + "static/index/assets/img/2.ff0d9b53.png";